module.exports = "<a ui-sref=\"finances.posicionbancaria()\">\r\n\t<app-launcher color=\"#E91E63\">\r\n\t\t<icon>Pb</icon>\r\n\t\t<label>Posición Bancaria</label>\r\n\t</app-launcher>\r\n</a>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/finanzas/components/posicionbancaria/launcher/template.html
// module id = 2798
// module chunks = 0